import type { Question } from '@mentimeter/legacy-series-types/question';
import type { Slide as VotingSlide } from '../../compatibility-overrides/voting-types';
import type { CompatibilitySlide } from '../../compatibility-types';

export const getQuestionRankingProperty = (
  target: CompatibilitySlide<'ranking'> | VotingSlide<'ranking'>,
  prop: keyof Question,
) => {
  const staticContents = target.staticContent;

  if (prop === 'question_styled') {
    return staticContents.styledTitle ?? {};
  }

  return undefined;
};
